<!--  -->
<template>
  <div class="content">
    <div class="footer">
      <div class="card">
        <div class="left">
          <div class="title">联系我们</div>
          <div class="text flex">
            电话：
            <div class="phone">
              <p>0731－82250973</p>
            </div>
          </div>
          <div class="text flex">
            邮箱：
            <div class="phone">
              <p> jyzx@hital.com</p>
            </div>
          </div>
          <div class="text flex">
            地址：
            <div class="phone">
              <p>湖南省长沙市芙蓉区芙蓉中路<br />二段111号华菱大厦20楼</p>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <div class="left">
          <div class="title">网站导航</div>
          <div class="text">
            <ul>
              <li>
                <a href="#" @click="topUrl(0, '/')" class="">网站首页</a>
              </li>
              <li>
                <a
                  href="#"
                  @click="topUrl(1, '/Service_education')"
                  class="padd_left"
                  >产品服务</a
                >
              </li>
              <li>
                <a href="#" @click="topUrl(2, '/New')" class="padd_left"
                  >新闻资讯</a
                >
              </li>
              <li>
                <a href="#" @click="topUrl(3, '/Contact_us')" class="padd_left"
                  >联系我们</a
                >
              </li>
              <!-- <li>
                <a href="#" @click="topUrl(4, '/About')" class="padd_left"
                  >关于我们</a
                >
              </li> -->
            </ul>
          </div>
          <div style="display: flex;justify-content: space-between;
      align-items: center;">
            <div>
              <div class="title" style="padding-top: 45px">友情链接</div>
              <div class="text link">
                <a
                  href="http://www.hital.com/"
                  target="_blank"
                  style="color: #bfc4cf"
                >
                  浩通国际货运代理有限公司官网
                </a>
              </div>
            </div>
            <div style="padding-left:30px">
              <div class="title" style="padding-top: 45px">技术支持</div>
              <div class="text link">
                <a
                  href="http://www.hitalgroup.com/"
                  target="_blank"
                  style="color: #bfc4cf"
                >
                  湖南浩通科技有限公司
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <div class="left">
          <div class="title">扫一扫 &nbsp;&nbsp;关注我们</div>
          <div class="er"><img src="../assets/servie/erwei.png" alt="" /></div>
          <div class="text left">“海驼课堂”公众号</div>
        </div>
      </div>
      <div class="foot">
        版权所有©2021-{{year}}湖南生易圈教育咨询有限公司 保留一切版权 <a style="color:#ccc" href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_bank">湘ICP备2021010616号-1</a> <br/>

       <a style="color:#ccc;" class="flexs" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=43010202001467" target="_bank">
       <img src="http://www.hital.com/images/beian.png" />
       
        湘公网安备43010202001467号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      year:'',
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //跳转
    topUrl(index, url) {
      this.$router.push(url);
      this.$store.state.current = index;
      this.current = index;
      localStorage.setItem("current", this.current);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
     var myDate = new Date();
    var year = "";

    year = myDate.getFullYear();
    this.year=year;
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="less">
.flexs{
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 10px;
}
@screen-lg-min: 768px;
/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) {
  .footer {
    width: 100%;
    background: #161e30;
    color: #fff;
    .card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 50px 50px 50px 0px;
      img {
        width: 136px;
      }
      .row {
        width: 1px;
        height: 200px;
        background: #454b59;
      }
      .title {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 500;
        color: #ffffff;
        padding-bottom: 20px;
      }
      .text,
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #bfc4cf;
        line-height: 30px;
      }
      .text ul {
        display: flex;
        a {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #bfc4cf;
          line-height: 30px;
        }
        .padd_left {
          padding: 0 15px;
        }
      }
      .flex {
        display: flex;
        padding-bottom: 10px;
      }
      .link {
        text-decoration: underline;
        text-align: center;
        cursor: pointer;
        text-align: left;
        margin-top: -10px;
      }
      .left {
        // margin-left: -10px;
      }
    }
    .foot {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #cccccc;
      text-align: center;
      border-top: 1px solid #333333;
      padding: 10px 0;
    }
  }
}

@screen-sm-min: 375px;

/* 手机（等于 375px） */
@media (max-width: @screen-sm-min) {
  .footer {
    width: 100%;
    background: #161e30;
    color: #fff;
    text-align: center;
    padding: 20px 0 0 0;
    .card {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 0 20px;
      img {
        width: 136px;
      }
      .row {
        width: 1px;
        height: 200px;
        background: #454b59;
        display: none;
      }
      .title {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 500;
        color: #ffffff;
        padding-bottom: 20px;
      }
      .text,
      p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #bfc4cf;
        line-height: 30px;
      }
      .text ul {
        display: flex;
        flex-wrap: wrap;
        a {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #bfc4cf;
          line-height: 30px;
        }
        .padd_left {
          padding: 0 5px;
        }
      }
      .flex {
        // display: flex;
        padding-bottom: 10px;
      }
      .link {
        text-decoration: underline;
        text-align: center;
        cursor: pointer;
        // text-align: left;
        margin-top: -10px;
      }
      .left {
        // margin-left: -10px;
        width: 100%;
      }
    }
    .foot {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #cccccc;
      text-align: center;
      border-top: 1px solid #333333;
      padding: 10px 0;
    }
  }
}
</style>